// Broadcast only a session-change signal; never put identity or tokens in storage.
export function notifyWebsiteSessionChanged() {
  window.dispatchEvent(new Event('site-access-changed'));
  if (typeof BroadcastChannel !== 'undefined') {
    const channel = new BroadcastChannel('magellan-website-access');
    channel.postMessage('session-changed');
    channel.close();
  }
}
